<template>
  <section id="map-bottom-popup">
    <el-drawer
      title="港美新世界"
      :with-header="false"
      :visible="modelValue"
      :modal-append-to-body="true"
      direction="btt"
      size="100%"
      :modal="false"
    >
      <div class="relic-close">
        <img
          @click="handleClosePopup"
          class="el-icon-close"
          src="../../assets/images/map_close.svg"
        />
      </div>
      <map-bottom-popup-header-vue
        :mapRelicDetail="mapRelicDetail"
        @onZhanKai="handleZhanKaiClick"
      />
      <map-bottom-popup-info-vue
        v-if="visbileInfo"
        :mapRelicDetail="mapRelicDetail"
      />
      <!-- <map-bottom-popup-swiper-vue :relicImg="relicPhoto"/>
      <map-bottom-popup-swiper-vue :relicImg="relicDrawing"/> -->
      <map-bottom-popup-swiper-vue
        v-for="(item, index) in images"
        :key="index"
        :relicImg="item"
        :type="index"
      />
      <map-bottom-point-cloud-vue
        v-if="mapRelicDetail.relicEditPageInfoDTO.pointCloudUrl"
        :pointUrl="mapRelicDetail.relicEditPageInfoDTO.pointCloudUrl"
        iframeTitle="点云模型"
      />
      <map-bottom-point-cloud-vue
        v-if="mapRelicDetail.relicEditPageInfoDTO.realSceneryModel"
        :pointUrl="mapRelicDetail.relicEditPageInfoDTO.realSceneryModel"
        iframeTitle="实景模型"
      />
      <!-- <map-bottom-model-vue
        :pid="pid"
        v-if="mapRelicDetail.relicEditPageInfoDTO.realSceneryModel"
      /> -->
    </el-drawer>
  </section>
</template>

<script>
import { modelMixin } from '../../assets/js/mixins/model';
import mapBottomPopupInfoVue from './map-bottom-popup-info.vue';
import mapBottomPopupSwiperVue from './map-bottom-popup-swiper.vue';
import mapBottomPopupHeaderVue from './map-bottom-popup-header.vue';
import { LEVEL_MAP, TYPE_MAP } from '../../config/constant';
import mapBottomPointCloudVue from './map-bottom-point-cloud.vue';
import { mapGetters } from 'vuex';
function compare(arg) {
  return function(a, b) {
    return a[arg] - b[arg];
  };
}
export default {
  name: 'MapBottomPopup',
  components: {
    mapBottomPopupInfoVue,
    mapBottomPopupSwiperVue,
    mapBottomPopupHeaderVue,
    mapBottomPointCloudVue
  },
  props: {
    mapRelicDetail: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters('login', ['isMobile']),
    visbileInfo() {
      if (this.isMobile) {
        return this.isMobile;
      } else {
        return this.showInfo;
      }
    },
    pid() {
      let pid = this.realSceneryModel.split('=')[1];

      return pid;
    }
  },
  watch: {
    mapRelicDetail: {
      immediate: true,
      handler() {
        const visiblePhotoSort = this.mapRelicDetail.photos.every(item => {
          return item.photoId;
        });
        if (visiblePhotoSort) {
          this.mapRelicDetail.photos = this.mapRelicDetail.photos.sort(
            compare('photoId')
          );
        }
        this.images[0].imgList = this.mapRelicDetail.photos;
        const visibleSort = this.mapRelicDetail.drawings.every(item => {
          return item.drawingId;
        });
        if (visibleSort) {
          this.mapRelicDetail.drawings = this.mapRelicDetail.drawings.sort(
            compare('drawingId')
          );
        }
        this.images[1].imgList = this.mapRelicDetail.drawings;
        this.realSceneryModel = this.mapRelicDetail.relicEditPageInfoDTO.realSceneryModel;
        this.mapRelicDetail.relicEditPageInfoDTO.relicTypeEnum = TYPE_MAP.get(
          this.mapRelicDetail.relicEditPageInfoDTO.relicTypeEnum
        );
        this.mapRelicDetail.relicEditPageInfoDTO.protectionLevelEnum = LEVEL_MAP.get(
          this.mapRelicDetail.relicEditPageInfoDTO.protectionLevelEnum
        );
        this.images[2].imgList = this.mapRelicDetail.pointcloudPhotos;
      }
    }
  },
  data() {
    return {
      realSceneryModel: '',
      showInfo: false,
      relicDetail: '',
      images: [
        {
          type: '照片',
          imgList: this.mapRelicDetail.photos
        },
        {
          type: '图纸',
          imgList: this.mapRelicDetail.drawings
        },
        {
          type: '点云切片',
          imgList: this.mapRelicDetail.drawings
        }
      ],
      swiperOption: {
        slidesPerView: 4
      }
    };
  },
  mixins: [modelMixin],
  methods: {
    /**
     * 关闭弹窗回调
     */
    handleClosePopup() {
      this.modelValue = false;
    },
    handleZhanKaiClick(transformContrl) {
      this.showInfo = transformContrl;
    }
  }
};
</script>

<style lang="scss">
#map-bottom-popup {
  position: relative;
  width: 100%;
  .el-drawer__wrapper {
    top: calc(100vh - 446px);
  }
  .el-drawer {
    position: relative;
    min-height: 446px;
    // top: 60vh;
    &__close-btn {
      .el-icon {
        font-size: 30px;
      }
    }
    &__body {
      padding: 28px 40px;
    }
  }
  #el-drawer__title {
    span {
      font-size: 22px;
      font-weight: 700;
      color: #000;
    }
  }
  .el-drawer__wrapper {
    position: relative !important;
    overflow: visible;
  }
  .relic-close {
    position: relative;
    .el-icon-close {
      position: absolute;
      top: 0;
      right: -20px;
      width: 22px;
      height: 22px;
    }
  }
}
</style>
